module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Snow-d0813958a7d9ecd1abf65587971fe531f1f5218e75e8cd2a19ecda338ee8ebdf.svg";